const hexify = (string) => (string ? `#${string}` : undefined);

export default hexify;
